<template>
    <Fragment>
        <Portal to="header-actions">
            <AntButton
                icon="key"
                @click="$refs.apiKeyDrawer.show()"
            >
                {{ $t('apiKeys') }}
            </AntButton>
            <AntButton
                icon="lock"
                @click="$refs.MeasureAccessDrawer.show()"
            >
                {{ $t('measureAccess') }}
            </AntButton>
            <ConfirmDangerousAction @confirm="deleteCustomer">
                <AntButton icon="delete">
                    {{ $t('delete') }}
                </AntButton>
            </ConfirmDangerousAction>
            <AntButton
                icon="edit"
                type="primary"
                @click="editCustomer"
            >
                {{ $t('edit') }}
            </AntButton>
        </Portal>
        <Card
            class="max-w-3xl"
            :loading="loader.processing"
        >
            <CustomerInfo
                :loading="loader.loading"
                :customer="customer"
            />
        </Card>

        <MeasureAccessDrawer
            ref="MeasureAccessDrawer"
            :customer-id="customer.id"
        />
        <ApiKeysDrawer
            ref="apiKeyDrawer"
            :api-keys="customer.apiKeys"
        />
    </Fragment>
</template>
<script>
import MeasureAccessDrawer from '@/components/measures/MeasureAccessDrawer.vue';
import ConfirmDangerousAction from '@/components/ConfirmDangerousAction.vue';
import ApiKeysDrawer from '@/components/customers/ApiKeysDrawer.vue';
import CustomerInfo from '@/components/customers/CustomerInfo.vue';
import { Button } from 'ant-design-vue';
import resourceMixin from '@/mixins/resourceMixin';

export default {
    name: 'CustomerView',
    components: {
        AntButton: Button,
        CustomerInfo,
        ApiKeysDrawer,
        ConfirmDangerousAction,
        MeasureAccessDrawer,
    },
    mixins: [resourceMixin('customers')],
};
</script>

<style></style>
